import { classes } from '@theme/constants';
import { parseHtml } from '@theme/dom';
import { text } from '@theme/fetch';
import { HTMLShopifySectionElement } from '@theme/html-shopify-section-element';
import { productRecommendationsResponseHandler } from '@theme/product-recommendations';

class CartRecommendations extends HTMLShopifySectionElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    if (!this.hasAttribute('product-id') || this.getAttribute('product-id') === '') return;

    text(
      fetch(
        `${theme.routes.product_recommendations_url}?product_id=${this.getAttribute('product-id')}&section_id=${this.sectionId}`,
      ),
      productRecommendationsResponseHandler,
    ).then((response) => {
      const section = parseHtml(response);
      const element = section.querySelector(this.tagName.toLowerCase());

      if (element.childElementCount) {
        this.innerHTML = element.innerHTML;

        this.classList.add(classes.active);
      }
    });
  }
}

if (!customElements.get('cart-recommendations')) customElements.define('cart-recommendations', CartRecommendations);
